import {useState, useEffect} from 'react'

const EditProfileSettings = ({language, profile, setProfile, profileName, showSaveProfileBtn, setShowSaveProfileBtn}) => {
    const [isReadonly, setIsReadonly] = useState()
    const [hasAccessToSettings, setHasAccessToSettings] = useState()
    const [hasAccessToModels, setHasAccessToModels] = useState()
    const [hasAccessToProfiles, setHasAccessToProfiles] = useState()
    

    useEffect(() => {
          
        const getData = async () => {
            setIsReadonly(profile.isReadonly)
            setHasAccessToSettings(profile.hasAccessToSettings)
            setHasAccessToModels(profile.hasAccessToModels)
            setHasAccessToProfiles(profile.hasAccessToProfiles)
        }
    
        getData()
    },[profile])

    const handleChange = (input, value) => {
        if(input === "isReadonly")  setIsReadonly(value)
        if(input === "hasAccessToSettings")   setHasAccessToSettings(value)
        if(input === "hasAccessToModels")   setHasAccessToModels(value)
        if(input === "hasAccessToProfiles")   setHasAccessToProfiles(value)
        setShowSaveProfileBtn(true)
    }

    const updateProfile = async () => {
        let error = false
        if(profileName === ""){error = true}
        if(!error){
            var graphql = JSON.stringify({
                query: `mutation($id: Long, $solutionId: Int, $profileName: String, $isReadonly: Boolean, $hasAccessToSettings: Boolean, $hasAccessToModels: Boolean, $hasAccessToProfiles: Boolean) {
                            updateProfile(id:$id, solutionId:$solutionId, profileName: $profileName, isReadonly: $isReadonly, hasAccessToSettings: $hasAccessToSettings, hasAccessToModels: $hasAccessToModels, hasAccessToProfiles: $hasAccessToProfiles) {
                                id
                            }
                        }`,
                variables: {
                    "id": profile.id
                    , "solutionId": profile.solutionId
                    , "profileName": profileName
                    , "isReadonly": isReadonly
                    , "hasAccessToSettings": hasAccessToSettings
                    , "hasAccessToModels": hasAccessToModels
                    , "hasAccessToProfiles": hasAccessToProfiles
                }
            })
            const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
                method:'POST',
                headers:{
                    'Authorization':'Basic ' + global.config.Editor.authToken
                    ,'Content-Type': 'application/json'
                },
                body: graphql
            })
            .then(response => response.text())
            .then(result => {
                const resData = JSON.parse(result).data
                setShowSaveProfileBtn(false)
                return resData

            })
            .catch(error => console.log('error', error))
            const data = await res
            return data
        }
    }

    let content

    if(profile){
        content = (
            <>
                <label className="input_label checkbox">
                    <input type="checkbox" name="accessCreate" checked={isReadonly} onChange={ e => handleChange('isReadonly',isReadonly ? false : true)  } />
                    <span>{language.value === 'DA' ? 'Kun med læserettigheder' : 'Readonly'}</span>
                </label>
                <h4>{language.value === 'DA' ? 'Kontrolpanel Adgang:' : 'Control Panel Access:'}</h4>
                <label className="input_label checkbox">
                    <input type="checkbox" name="accessCreate" checked={hasAccessToSettings} onChange={ e => handleChange('hasAccessToSettings',hasAccessToSettings ? false : true) } />
                    <span>{language.value === 'DA' ? 'Indstillinger' : 'Settings'}</span>
                </label>
                <label className="input_label checkbox">
                    <input type="checkbox" name="accessCreate" checked={hasAccessToModels} onChange={ e => handleChange('hasAccessToModels',hasAccessToModels ? false : true) } />
                    <span>{language.value === 'DA' ? 'Indholds modeller' : 'Content models'}</span>
                </label>
                <label className="input_label checkbox">
                    <input type="checkbox" name="accessCreate" checked={hasAccessToProfiles} onChange={ e => handleChange('hasAccessToProfiles',hasAccessToProfiles ? false : true) } />
                    <span>{language.value === 'DA' ? 'Profiler/Brugere' : 'Profiles/Users'}</span>
                </label>
                {
                    (showSaveProfileBtn) &&
                    <div className="align_right">
                        <button className="cc-btn blue-gradient" onClick={updateProfile}>{language.value === 'DA' ? 'GEM ÆNDRINGER' : 'SAVE CHANGES'}</button>
                    </div>
                }
            </>
        )
    }


    return (
        <div>
            {content}
        </div>
    )
}

export default EditProfileSettings
